import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';
import CloseShape from '@/components/common/svg/shapes/CloseShape.tsx';

const CloseModalButton = ({ handleClose }: { handleClose: () => void }) => (
  <div onClick={handleClose} style={closeButtonContainerStyle}>
    <CloseShape
      fillColor={UIConfig.Colors.BackgroundLight}
      width={35}
      height={35}
      strokeWidth={1}
    />
  </div>
);

const closeButtonContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '45px',
  height: '45px',
  borderRadius: '50%',
  cursor: 'pointer'
};

export default CloseModalButton;
